import { useState, useEffect, useRef } from 'react';

const useGetWidth = (props) => {
  const currentWidth = document.body.offsetWidth;
  const [width, setWidth] = useState(currentWidth);
  const timeoutRef = useRef(null);

  useEffect(() => {
    const handler = () => {
      timeoutRef.current && clearTimeout(timeoutRef.current);
      timeoutRef.current = setTimeout(() => {
        setWidth(document.body.offsetWidth);
      }, 300);
    };
    window.addEventListener('resize', handler);

    return () => {
      timeoutRef.current && clearTimeout(timeoutRef.current);
      window.removeEventListener('resize', handler);
    };
  }, []);

  return width;
};

export default useGetWidth;
